import { createContext, useContext } from 'react';

// Paleta del canvas por tema. Los nodos custom de React Flow no reciben props
// del componente padre, así que el tema viaja por contexto.
export const NODE_THEMES = {
  dark: {
    cardBg: '#111b21',
    border: '#2a3942',
    borderStrong: '#4e606b',
    textPrimary: '#e9edef',
    textSecondary: '#aebac1',
    canvasDots: '#222e35',
    edge: '#4e606b',
    panelBg: '#111b21',
    inputBg: '#202c33',
    textTertiary: '#9fb4b9',
    accent: '#5DCCED',
  },
  light: {
    cardBg: '#FFFFFF',
    border: '#e3e9ec',
    borderStrong: '#C3C3C3',
    textPrimary: '#2D2D2D',
    textSecondary: '#555555',
    canvasDots: '#cfdde3',
    edge: '#9fb1ba',
    panelBg: '#FFFFFF',
    inputBg: '#f4fafc',
    textTertiary: '#747474',
    accent: '#0a7ba5',
  },
};

// El valor por defecto es el tema claro; BotsConstructor provee el real.
export const NodeThemeContext = createContext(NODE_THEMES.light);

export const useNodeTheme = () => useContext(NodeThemeContext);
